import React from 'react';
import { Clock, Phone, ShieldCheck } from 'lucide-react';
export function UtilityBar() {
  return <div className="bg-navy text-white text-xs sm:text-sm py-2 px-4 relative" data-id="element-568">
      {/* Subtle bottom gradient border */}
      <div className="absolute bottom-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-orange/50 to-transparent" data-id="element-569"></div>

      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row justify-between items-center gap-2 relative z-10" data-id="element-570">
        <div className="flex flex-wrap justify-center items-center gap-4" data-id="element-571">
          <span className="flex items-center gap-1.5 font-medium" data-id="element-572">
            <Clock className="w-4 h-4 text-orange" data-id="element-573" />
            Open 24 Hours
          </span>
          <span className="hidden md:flex items-center gap-2 text-orange font-bold tracking-wide" data-id="element-574">
            <span className="relative flex h-2.5 w-2.5" data-id="element-575">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-orange opacity-75" data-id="element-576"></span>
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-orange" data-id="element-577"></span>
            </span>
            24hr Emergency Service
          </span>
        </div>
        <div className="flex items-center gap-5" data-id="element-578">
          <span className="hidden sm:flex items-center gap-1.5 text-gray-300 font-medium" data-id="element-579">
            <ShieldCheck className="w-4 h-4 text-emerald-500" data-id="element-580" />
            Fully Licensed & Insured
          </span>
          <a href="tel:0418381988" className="flex items-center gap-1.5 font-bold hover:text-orange transition-colors" data-id="element-581">
            <Phone className="w-4 h-4" data-id="element-582" />
            0418 381 988
          </a>
        </div>
      </div>
    </div>;
}